module.exports = function(h, row) {
    return (
        <div>
            <label class="md-check">
                <input
                    type="checkbox"
                    onChange={e => this.onChangeSelectAll(e.target.checked)}
                    checked={this.selectedAll}
                />
                <i class="indigo" />
            </label>
        </div>
    );
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/promotion/heading-select-station.jsx